/**
 * AuthLayout — lightweight chrome for screens that render OUTSIDE the main
 * Shell (sign-in, login, verify-email, add-device, join, brokerage/agent
 * landings, callback). They previously had no header at all.
 *
 * Renders a slim top bar with a Home button (left) and the DesignToggle
 * (right), then the routed page via <Outlet/>. The bar is fixed and
 * transparent so it overlays the centered auth cards without shifting them.
 *
 * Wire up in router.tsx by nesting the standalone auth routes under this:
 *   { element: <AuthLayout />, children: [ ...auth routes ] }
 */
import { Home as HomeIcon } from "lucide-react";
import { Link, Outlet } from "react-router";

import { APP_NAME } from "../brand";
import { DesignToggle } from "./DesignToggle";

export function AuthLayout() {
  return (
    <>
      <header
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 50,
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          background: "rgba(255,255,255,0.72)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          borderBottom: "1px solid var(--rp-color-border)",
        }}
      >
        <Link
          to="/"
          aria-label="Home"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 9,
            textDecoration: "none",
            color: "var(--rp-color-text)",
            fontWeight: 800,
            fontSize: 15,
            letterSpacing: "-0.01em",
          }}
        >
          <span
            style={{
              width: 30,
              height: 30,
              borderRadius: 9,
              background: "var(--rp-color-primary)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <HomeIcon size={16} color="#fff" strokeWidth={2.4} />
          </span>
          {APP_NAME}
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <DesignToggle />
        </div>
      </header>

      <Outlet />
    </>
  );
}
